import Header from "@/atomic/atoms/Header";
import useI18n from "@/hooks/useI18n";
import { PropsView } from "./Models";

export default function TermsView({ goBack }: PropsView) {
  const { t, isLanguage } = useI18n();

  const getPdfPath = () => {
    return isLanguage("es-ES")
      ? "/termos-e-condicoes-es.pdf"
      : "/termos-e-condicoes.pdf";
  };

  return (
    <div className="h-full">
      <Header
        title={t("pages:welcome:labelTerms")
          .replace(/<[^>]*>/g, "")
          .trim()}
        goBack={goBack}
        hasLeftButton
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <div className="h-full flex flex-col justify-between w-full">
          <div className="w-full h-full">
            <iframe
              title={t("pages:welcome:labelTerms")
                .replace(/<[^>]*>/g, "")
                .trim()}
              src={getPdfPath()}
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div>
      </main>
    </div>
  );
}
